import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Language/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import LangTable from 'components/Web_User_Interface/1440p_Series/System/Language/langTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Sprache",
  "path": "/Web_User_Interface/1440p_Serie/System/Sprache/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Ändern Sie die Sprache der Weboberfläche in Deutsch, Englisch, Französisch oder Chinesisch. Die Weboberfläche setzt die Sprache automatisch auf die Sprache Ihres Betriebssystems. Sie können es manuell ändern, falls die automatische Erkennung fehlgeschlagen ist oder Sie die Weboberfläche in einer anderen Sprache darstellen möchten. Ihre Einstellungen werden lokal als Cookie gespeichert und nicht global auf der Kamera selbst.",
  "image": "./WebUI_1440p_SearchThumb_System_Language.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Language.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // Sprache' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ändern Sie die Sprache der Weboberfläche in Deutsch, Englisch, Französisch oder Chinesisch. Die Weboberfläche setzt die Sprache automatisch auf die Sprache Ihres Betriebssystems. Sie können es manuell ändern, falls die automatische Erkennung fehlgeschlagen ist oder Sie die Weboberfläche in einer anderen Sprache darstellen möchten. Ihre Einstellungen werden lokal als Cookie gespeichert und nicht global auf der Kamera selbst.' image='/images/Search/WebUI_1440p_SearchThumb_System_Language.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Language.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Language/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Language/' crumbLabel="Language" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "stellen-sie-die-sprache-der-oberfläche-ein",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#stellen-sie-die-sprache-der-oberfl%C3%A4che-ein",
        "aria-label": "stellen sie die sprache der oberfläche ein permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Stellen Sie die Sprache der Oberfläche ein`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/457046662a45667d8aa242a85e0294aa/d9199/1440p_Settings_System_Language.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.130434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACLklEQVQoz23Q20uTcRzH8f0XHSCwYkf3OBS3Z8fnsN+ex23u9BzcdB1QkgLxImcZTUhQCvKqUkmwOyGCMqOiIummgkCwi277Y96xNUupi9fN7+LN5/vzRCIRwmGJgPcc8XwT9+4epfZLRtu7mLd2MBb+lVvYoby4w/i9j5QvztJ35jQnTp6i72wfnv7+fjr83vMkRIULt7eotx7SuLGG21rDnetpHVrHbW0wfnOdS+0tjEqTSFhiYGAQSYr0gqEQgUCQ6PAQDadC3SpRt8s0jnAqBWqlEayioJZXqI4oWMUsQs+RSQt0zSSZyPxdGAgEiMkyjfEJHNfFcY6znTGsWhVrar63/BHO1UUKpomuZlEVQVxOHTnZ7ycWi1Gv17Es6z9q2NUSVvMKzrV2l3V5FtcyMISG0g2mjwdlWe4GHcfpsm0b23awa1XGZpaZWHpG4/oD7ms6T1SNtjBw6yamUFAzWZKJ3sJQKEQwGESSpO7KaHQYTdWpVkvYdoFC3mSkWCZXtChXbVrTkzzd3GR79Q7Nmo6uqphCJ5VM4unEDnX+0efzdcmxJEIYjBYFSiaDXc4zPzPJysoKe5/e8eP7N36+2WV5qoGipDFFlkQ8hacTObqyo/OWSmTI6jlywqA2WmJjdYnXL7b5vL/PwZcPfH31nIP3b3k8N03JUNBU8fvkTiAcDv9ZeBj0+fw9PgYjEkpSJhYdJp1OoWUSKMk4mq4SGxqgP+jD6/Xj9Xr5BSkxfiaghqn9AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/457046662a45667d8aa242a85e0294aa/e4706/1440p_Settings_System_Language.avif 230w", "/de/static/457046662a45667d8aa242a85e0294aa/d1af7/1440p_Settings_System_Language.avif 460w", "/de/static/457046662a45667d8aa242a85e0294aa/7f308/1440p_Settings_System_Language.avif 920w", "/de/static/457046662a45667d8aa242a85e0294aa/542bc/1440p_Settings_System_Language.avif 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/457046662a45667d8aa242a85e0294aa/a0b58/1440p_Settings_System_Language.webp 230w", "/de/static/457046662a45667d8aa242a85e0294aa/bc10c/1440p_Settings_System_Language.webp 460w", "/de/static/457046662a45667d8aa242a85e0294aa/966d8/1440p_Settings_System_Language.webp 920w", "/de/static/457046662a45667d8aa242a85e0294aa/e46b2/1440p_Settings_System_Language.webp 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/457046662a45667d8aa242a85e0294aa/81c8e/1440p_Settings_System_Language.png 230w", "/de/static/457046662a45667d8aa242a85e0294aa/08a84/1440p_Settings_System_Language.png 460w", "/de/static/457046662a45667d8aa242a85e0294aa/c0255/1440p_Settings_System_Language.png 920w", "/de/static/457046662a45667d8aa242a85e0294aa/d9199/1440p_Settings_System_Language.png 960w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/457046662a45667d8aa242a85e0294aa/c0255/1440p_Settings_System_Language.png",
              "alt": "Web User Interface - 1440p Series - System Language",
              "title": "Web User Interface - 1440p Series - System Language",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Hier können Sie die Sprache der Weboberfläche auswählen. Die Weboberfläche wird neu laden, nachdem Sie auf Bestätigen gedrückt haben.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <LangTable mdxType="LangTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      